import log from 'sentry/log'

const parseChannelData = (channel) => {
  let channelData
  try {
    channelData = JSON.parse(channel.data)
  } catch (error) {
    log.message("Chat: Couldn't parse JSON from channel.data")
  }
  return channelData
}

export const channelOlderThanOneYear = (channel) => {
  /* If the channel is from the old MC the 'channel.createdAt'
    will be the date when the replication was done. In that case
    the real createdAt date will be found in the data object */
  const channelData = parseChannelData(channel)
  const createdAt = (channelData && Number(channelData.createdAt)) || channel.createdAt
  const timeSinceCreated = Date.now() - createdAt
  const oneYear = 31536000000 //  one year in milliseconds
  return timeSinceCreated > oneYear
}
